const state = () => ({
  status: 200, // 200 404 408
  type: 'piclive',
  corpId: 0,
  channelInfo: {},
  menuList: [],
  advertTop: {
    status: false,
    list: [],
    close: 0
  },
  advertMiddle: {
    status: false,
    list: [],
    close: 0
  },
  userInfo: {},
  globalSetting: {}
})
export default state
